import { render } from "./statistics_chart3.vue?vue&type=template&id=ecab6588&scoped=true"
import script from "./statistics_chart3.vue?vue&type=script&lang=js"
export * from "./statistics_chart3.vue?vue&type=script&lang=js"

import "./statistics_chart3.vue?vue&type=style&index=0&id=ecab6588&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecab6588"]])

export default __exports__